const chavesDownloadAtivo = new Set();

function obterChaveArquivo(arquivo) {
  if (!arquivo) {
    return '';
  }

  return (
    arquivo.IdArquivoDigital ||
    arquivo.UrlArquivoDigital ||
    arquivo.NomeArquivoDigital ||
    ''
  );
}

function downloadEstaAtivo(chave) {
  return Boolean(chave) && chavesDownloadAtivo.has(chave);
}

function marcarDownloadAtivo(chave) {
  if (!chave || chavesDownloadAtivo.has(chave)) {
    return false;
  }

  chavesDownloadAtivo.add(chave);
  return true;
}

function desmarcarDownloadAtivo(chave) {
  chavesDownloadAtivo.delete(chave);
}

function formatarTamanhoBytes(bytes) {
  const tamanho = Number(bytes);
  if (!Number.isFinite(tamanho) || tamanho <= 0) {
    return '';
  }

  const kb = 1024;
  const mb = kb * 1024;
  const gb = mb * 1024;

  if (tamanho >= gb) {
    return `${(tamanho / gb).toFixed(1).replace('.', ',')} GB`;
  }
  if (tamanho >= mb) {
    return `${(tamanho / mb).toFixed(1).replace('.', ',')} MB`;
  }
  if (tamanho >= kb) {
    return `${Math.max(1, Math.round(tamanho / kb))} KB`;
  }

  return `${Math.round(tamanho)} B`;
}

function obterPercentualDownload(progresso) {
  if (!progresso || !progresso.total || progresso.total <= 0) {
    return null;
  }

  const percentual = Math.round((progresso.recebido / progresso.total) * 100);
  return Math.min(100, Math.max(0, percentual));
}

function obterTextoProgressoDownload(progresso) {
  if (!progresso) {
    return '';
  }

  const recebidoFmt = formatarTamanhoBytes(progresso.recebido);
  const totalFmt = formatarTamanhoBytes(progresso.total);
  const percentual = obterPercentualDownload(progresso);

  if (totalFmt && recebidoFmt && percentual !== null) {
    return `Carregando ${recebidoFmt} de ${totalFmt} (${percentual}%)`;
  }
  if (recebidoFmt) {
    return `Carregando ${recebidoFmt}…`;
  }

  return 'Preparando arquivo…';
}

function criarAtualizadorProgresso(onAtualizar) {
  let ultimo = 0;

  return function atualizar({ received, total }) {
    const agora = Date.now();
    const totalNumero = total || 0;
    const concluido = totalNumero > 0 && received >= totalNumero;

    if (!concluido && received > 0 && agora - ultimo < 120) {
      return;
    }

    ultimo = agora;
    onAtualizar({
      recebido: received || 0,
      total: totalNumero,
    });
  };
}

function ehAborto(erro) {
  return Boolean(erro && erro.name === 'AbortError');
}

function popupFoiBloqueado(janela) {
  return !janela || janela.closed;
}

function abrirNovaAba(url) {
  const janela = window.open(url, '_blank');
  return popupFoiBloqueado(janela) ? null : janela;
}

export {
  obterChaveArquivo,
  downloadEstaAtivo,
  marcarDownloadAtivo,
  desmarcarDownloadAtivo,
  formatarTamanhoBytes,
  obterPercentualDownload,
  obterTextoProgressoDownload,
  criarAtualizadorProgresso,
  ehAborto,
  popupFoiBloqueado,
  abrirNovaAba,
};
